import { WithName } from '@/types/common'
import { User } from '@/types/user'

// eslint-disable-next-line no-restricted-syntax
export enum GroupTypes {
	Department = 'department',
	Office = 'office',
	Company = 'company',
	PolicyGroup = 'policy_group',
	Expense = 'expense',
}

export interface Group extends WithName {
	id: number
	approver: User
	approver_user_id: number
	expense_approver: User
	expense_approver_user_id: number
	users_count: number
	type: Exclude<GroupTypes, GroupTypes.Expense>
}
